import styled from "styled-components";

export const StyledMain = styled.main`
  background-color: ${(props) => (props.grayBg ? "#f2f4f7" : "#fff")};
  grid-area: main;
  justify-self: center;
  width: 100%;
`;
